var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2439 5.91504C35.9116 5.91504 44.5729 14.5754 44.5732 25.243C44.5792 29.8558 42.9279 34.3177 39.9207 37.8156C39.9207 37.8156 46.1151 44.0122 50.0844 47.982L47.983 50.0834L37.8166 39.9197C34.4371 42.8189 30.0433 44.5723 25.2439 44.5723C14.5764 44.5719 5.91602 35.9106 5.91602 25.243C5.91636 14.5756 14.5766 5.91538 25.2439 5.91504ZM25.2439 8.88867C16.218 8.88902 8.88999 16.217 8.88965 25.243C8.88965 34.2692 16.2178 41.5983 25.2439 41.5986C34.2704 41.5986 41.5996 34.2694 41.5996 25.243C41.5993 16.2168 34.2702 8.88867 25.2439 8.88867ZM33.9639 19.818L27.5285 26.252L33.9639 32.6873L31.9842 34.667L25.5488 28.2316L19.1135 34.667L17.1338 32.6873L23.5691 26.252L17.1338 19.818L19.1135 17.8383L25.5488 24.2723L31.9842 17.8383L33.9639 19.818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearch);
export default __webpack_public_path__ + "static/media/NoSearch.775a057d6ad50df0e31b1a0f6e6f6eb8.svg";
export { ForwardRef as ReactComponent };